import { render, staticRenderFns } from "./SvgElement.vue?vue&type=template&id=60c754e5&"
import script from "./SvgElement.vue?vue&type=script&lang=ts&"
export * from "./SvgElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports